import Bugsnag from "@bugsnag/js";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { ReactComponent as IconArrowRight } from "@Icons/16x16/arrow-right.svg";
import { Section, Tile } from "@Types/pagify";
import { getLink } from "@Utils/pagify";
import "./style.scss";

export const MediumProductCards: FunctionComponent<{
  section: Section;
  tiles: Tile[];
}> = ({ section, tiles }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const cta = section.cta[0];

  return (
    <div className="MediumProductCards">
      <h1 className="MediumProductCards-title">{section.title}</h1>
      <div className="MediumProductCards-subtitle">
        {section.subtitle.map((textBlock) => (
          <div key={textBlock.text}>{textBlock.text}</div>
        ))}
      </div>
      <div className="MediumProductCards-wrapper">
        <div className="MediumProductCards-scroll">
          {tiles.map((tile) => {
            const tileTitle = tile.textBlock1 && tile.textBlock1[0].text;
            const tileImage = tile.images.length > 0 && tile.images[0].desktop;

            if (!tileImage) {
              Bugsnag.notify(
                new Error(`image for tile ${tile.slug} not found in MediumProductCards`)
              );
            }

            return (
              <a
                className="MediumProductCards-item"
                href={getLink(tile.navigationLink, localeSlug)}
                key={tile.slug}
              >
                {!!tileImage && (
                  <img
                    alt={tileTitle || tile.slug}
                    className="MediumProductCards-item-image"
                    height="208"
                    src={tileImage["1x"]}
                    srcSet={`${tileImage["1x"]} 1x, ${tileImage["2x"]} 2x`}
                    width="320"
                  />
                )}
                <div className="MediumProductCards-item-title">
                  {tileTitle}
                  <ButtonSmily
                    icon={<IconArrowRight />}
                    iconPosition="alone"
                    size="m"
                    type="secondary"
                  />
                </div>
              </a>
            );
          })}
        </div>
      </div>
      {!!cta && (
        <ButtonSmily
          href={getLink(cta.navigationLink, localeSlug)}
          icon={<IconArrowRight />}
          iconPosition="right"
          size="m"
          type="primary"
        >
          {cta.text}
        </ButtonSmily>
      )}
    </div>
  );
};
